import { Box, Grid, HStack, Text, VStack } from '@cdl/heartbeat-react';
import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { getAnnotationTask } from '../clients/annotation-task.client';
import { OverallPerformance } from './taskpage/overall/OverallPerformance';
import { AnnotationTask } from '../../ecg/types/annotation-tasks.type';
import { TopContributions } from './taskpage/TopContributions';
import { DailyCompletion } from './taskpage/DailyCompletion';
import { WorkingDays } from './taskpage/WorkingDays';
import { OverallProgress } from './taskpage/overall/OverallProgress';

export const TaskPage = () => {
  const { id } = useParams();
  const [annotationTask, setAnnotationTask] = useState<AnnotationTask>();

  useEffect(() => {
    async function fetchData() {
      if (id) {
        const annotation = await getAnnotationTask(id);
        if (annotation) setAnnotationTask(annotation);
      }
    }
    fetchData();
  }, [id]);

  return (
    <>
      {annotationTask && (
        <VStack alignItems='stretch' spacing='xl' w='full'>
          <Box>
            <HStack fontSize='xs' color='neutral.400'>
              <Text as='u'>
                <Link to={'/admin/dashboard'}>Dashboard</Link>
              </Text>
            </HStack>
            <Text mt='s' textStyle='section-title'>
              {annotationTask.name} {annotationTask.ecgDoneCount}/
              {annotationTask.ecgTotalCount}
            </Text>
          </Box>
          <Box>
            <Grid templateColumns='repeat(3, 1fr)' gap='m'>
              <OverallPerformance annotationTask={annotationTask} />
              <OverallProgress annotationTask={annotationTask} />
              <WorkingDays annotationTask={annotationTask} />
            </Grid>
            <Grid h='400px' templateColumns='repeat(3, 1fr)' gap='m' mt='m'>
              <DailyCompletion annotationTask={annotationTask} />
              <TopContributions annotationTask={annotationTask} />
            </Grid>
          </Box>
        </VStack>
      )}
    </>
  );
};
